import React, { createContext, type PropsWithChildren, useContext, useRef } from 'react';

import isEqual from 'lodash/isEqual';

import type { PopupDataContextData } from '../../types';

const initialValue: PopupDataContextData = { appItemsData: [], productItemsData: [] } as const;

export const PopupDataContext: React.Context<PopupDataContextData> =
	createContext<PopupDataContextData>(initialValue);

export type PopupDataProviderProps = PropsWithChildren<PopupDataContextData>;

export function PopupDataProvider(props: PopupDataProviderProps): React.JSX.Element {
	const { appItemsData, children, productItemsData } = props;
	const previousValue = useRef(initialValue);

	if (
		!isEqual(previousValue.current.appItemsData, appItemsData) ||
		!isEqual(previousValue.current.productItemsData, productItemsData)
	) {
		previousValue.current = { appItemsData, productItemsData };
	}

	return (
		<PopupDataContext.Provider value={previousValue.current}>{children}</PopupDataContext.Provider>
	);
}

export function usePopupData(): PopupDataContextData {
	return useContext(PopupDataContext);
}
